/**
 * Shared class strings for tandem CTA rows (two or more `size="lg"` buttons
 * side by side).
 *
 * Every button in the row must also carry `className="w-full"`. The grid gives
 * each column an equal fraction (`auto-cols-fr`) and `sm:w-fit` keeps the row
 * from stretching edge to edge, so the buttons stay the same width regardless
 * of how long the translated labels are. Ad-hoc `mr-4`, `space-x-4` and
 * `min-w-[200px]` rows all drift apart in de-DE and fr-FR; use these instead.
 *
 * `scripts/cta-row-audit.cjs` enforces this in CI.
 */
export const CTA_ROW = 'flex flex-col gap-4 sm:grid sm:w-fit sm:grid-flow-col sm:auto-cols-fr';

/** Same row, horizontally centred inside its container. */
export const CTA_ROW_CENTERED = `${CTA_ROW} sm:mx-auto`;
